/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useState } from "react"

import { useAITranslatorSettingsLocal } from "./use-ai-translator-settings-local"
import { defaultSettings } from "../constants/translator-defaults"

export function useChooseTranslateLanguage() {
  const [showAddLanguageDialog, setShowAddLanguageDialog] = useState(false)

  const { settings, updateSettings } = useAITranslatorSettingsLocal()

  const selectedLanguage = settings.selectedLanguage ?? defaultSettings.selectedLanguage
  const availableLanguages = settings.availableLanguages ?? defaultSettings.availableLanguages

  // Add a new language and select it in a single debounced update
  function handleAddLanguage(language: string) {
    const newLanguage = language.trim()
    if (!newLanguage) return

    // Avoid duplicates (case-insensitive)
    const exists = availableLanguages
      .map((l: string) => l.toLowerCase())
      .includes(newLanguage.toLowerCase())
    if (exists) {
      // Still ensure it's selected if it already exists
      updateSettings({ selectedLanguage: newLanguage })
      return
    }

    updateSettings({
      availableLanguages: [...availableLanguages, newLanguage],
      selectedLanguage: newLanguage,
    })
  }

  function handleChangeLanguage(language: string) {
    if (language === "add_new") {
      setShowAddLanguageDialog(true)
    } else {
      updateSettings({ selectedLanguage: language })
    }
  }

  function handleDeleteLanguage(languageToDelete: string) {
    const newAvailableLanguages = availableLanguages.filter(
      (language: string) => language !== languageToDelete
    )

    const updates: Partial<typeof settings> = {
      availableLanguages: newAvailableLanguages,
    }

    if (languageToDelete === selectedLanguage) {
      updates.selectedLanguage = newAvailableLanguages[0]
    }

    updateSettings(updates)
  }

  return {
    handleChangeLanguage,
    handleDeleteLanguage,
    handleAddLanguage,
    selectedLanguage,
    availableLanguages,
    showAddLanguageDialog,
    setShowAddLanguageDialog,
  }
}
